import type { SerializedCanvasItem } from '@/hooks/canvas/types';
import type { ApplyCanvasLayoutChangesToItemsParams } from '../types';

// Applies absolute position/size patches from a layout tool call onto the
// exhaustive items cache so revision-driven rehydrate does not flash old coords.
const applyCanvasLayoutChangesToItems = ({
    items,
    changes,
}: ApplyCanvasLayoutChangesToItemsParams): SerializedCanvasItem[] => {
    if (changes.length === 0) {
        return items;
    }

    const changesByItemId = new Map(changes.map(change => [change.itemId, change]));

    return items.map(item => {
        const change = changesByItemId.get(item.itemId);
        if (!change) {
            return item;
        }

        return {
            ...item,
            position: change.position ?? item.position,
            size: change.size ?? item.size,
        };
    });
};

export default applyCanvasLayoutChangesToItems;
